import React from 'react'
import helpBg from "../../assets/needhelp-bg.png"
import { Modal } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'


function NeedHelp({ isNeedOpen, setIsNeedOpen }) {
    console.log("renderinghekpkp", isNeedOpen)
    return (
        <div>
            <Modal
                open={isNeedOpen}
                onCancel={() => setIsNeedOpen(false)}
                footer={null}
                closeIcon={false}
                className='r-c-c token-model'
                maskClosable={false}
                style={{ overflow: 'hidden !important', top: "0px" }}
                bodyStyle={{ height: "100vh", width: "90vw", overflow: 'hidden !important', }}
            >
                <div className='r-c-c-c need-parent-div'>
                    <div className='need-div-1'>Need Help?</div>
                    <div className='need-div-2' onClick={() => setIsNeedOpen(false)}><CloseCircleOutlined /></div>
                    <div className='need-div-3' ><img src={helpBg} className='full-img' />

                    </div>
                    <div className='r-c-c-c need-div-4' >
                        <div className='need-div-5'>If you encounter an error message or have difficulty navigating, please follow these steps:</div>
                        <ul className='neeed-div-6'>
                            <li ><span style={{ fontWeight: "bold" }}>Refresh the Page:</span> Sometimes, a simple refresh can resolve the issue.</li>
                            <li > <span style={{ fontWeight: "bold" }}>Clear Cache:</span> Clearing your browser's cache can help fix many common problems.</li>
                            <li > <span style={{ fontWeight: "bold" }}>Contact Support:</span> If the issue presists, please reach out to our support team for assistance.</li>
                        </ul>


                        <center> For further help, email us at <center style={{ color: "#005275", fontWeight: "bold" }} >contact@thegamificationcompany.com. </center></center>
                    </div>
                </div>
            </Modal>
        </div>

    )
}

export default NeedHelp
